/* eslint-disable import/prefer-default-export */
export const getAvgRating = scores => {
  let sum = 0
  Object.keys(scores).forEach(score => {
    sum += scores[score]
  })
  const average = sum / 5
  return average
}
